import projectsData from '../data/projects.json';
import technologiesData from '../data/technologies.json';
import projectTechData from '../data/project_technologies.json';

import { Project } from '../models/project.interface';
import { Technology } from '../models/technology.interface';

export class ProjectsService {
    private projects: Project[] = [];
    private technologies: Technology[] = [];

    constructor() {
        this.technologies = technologiesData.technologies as Technology[];
        this.projects = projectsData.projects.map((project: any) => {
            const techLinks = projectTechData.project_technologies.filter(pt => pt.project_id === project.id);
            const technologies: Technology[] = [];
            techLinks.forEach(link => {
                const found = this.technologies.find(t => t.id === link.technology_id);
                if (found) technologies.push(found);
            });
            return { ...project, technologies } as Project;
        });
    }

    getProjects(): Project[] {
        return this.projects;
    }

    getTechnologies(): Technology[] {
        return this.technologies;
    }

    getProjectById(id: number): Project | undefined {
        return this.projects.find(p => p.id === id);
    }
}

export const projectsService = new ProjectsService();
